module.exports = __webpack_public_path__ + "static/media/negative.98a4e681.svg";